export enum Persona {
    ClientBillingSuperUser = "Client Billing Super User",
    ClientBillingManager = "Client Billing Manager",
    ClientBillingUser = "Client Billing User",
    ClientBillingTractUser = "Client Billing Tract User",
    ClientBillingFinanceUser = "Client Billing Finance User"
}
